import React from "react";
import { GiftIcon } from "lucide-react";
import { SectionCTA } from "./SectionCTA";
import { bonuses } from "../data/content";
export function Bonuses() {
  return <section className="bg-brand-900 py-16 text-white md:py-24" data-id="element-63" data-mp="plsnad7r1gdg">
      <div className="mx-auto max-w-5xl" data-id="element-64" data-mp="aujyg6bo7z1d">
        <div className="px-5 text-center md:px-8" data-id="element-65" data-mp="fu69c9411370">
          <p className="inline-flex items-center gap-2 text-sm font-bold text-gold-300" data-id="element-66" data-mp="fslh4q56pwcb">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-67" data-mp="1tltnlternhq" />
            And that's not all…
          </p>
          <h2 className="mt-3 text-3xl font-extrabold leading-tight tracking-tight md:text-[2.6rem]" data-id="element-68" data-mp="5xjtxzugz4cd">
            You'll also receive 5 exclusive clinical bonuses
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-brand-100" data-id="element-69" data-mp="3t1r9sfn0dm58">
            Each bonus complements the main roadmap with a practical tool for common consultation challenges.
          </p>
        </div>

        <div className="mt-12 space-y-10 md:space-y-14 md:px-8" data-id="element-70" data-mp="1r80ehv1b2q7y">
          {bonuses.map((b, i) => <article key={b.title} className="grid items-center overflow-hidden bg-white text-ink md:grid-cols-2 md:rounded-3xl" data-id="element-71" data-mp="3id52z1tcov8o" data-mpi={i}>
              <div className={`relative aspect-[4/3] w-full overflow-hidden bg-white ${i % 2 === 1 ? "md:order-2" : ""}`} data-id="element-72" data-mp="3r79tfk4ko4no">
                <img src={b.image} alt={`Bonus ${i + 1}: ${b.title}`} className="h-full w-full scale-[1.35] object-cover" loading="lazy" data-id="element-73" data-mp="3n6g18ek3k3oz" />
              </div>
              <div className="p-6 md:p-10" data-id="element-74" data-mp="38g8totvmo532">
                <div className="flex flex-wrap items-center gap-3" data-id="element-75" data-mp="38hbh2rtqrpe8">
                  <span className="rounded-md bg-gold-400 px-3 py-1 text-sm font-extrabold uppercase text-brand-950" data-id="element-76" data-mp="33hfduusvc1zq">
                    Bonus #{i + 1}
                  </span>
                  <span className="text-sm font-semibold text-muted" data-id="element-77" data-mp="nrukkm7xk144">
                    Comparison value: <span className="line-through" data-id="element-78" data-mp="it13ykxcjtzq">${b.value}</span>{" "}
                    <span className="font-extrabold text-emerald-600" data-id="element-79" data-mp="3ciemd4oadwzm">Included free</span>
                  </span>
                </div>
                <h3 className="mt-4 text-2xl font-extrabold leading-snug text-brand-900" data-id="element-80" data-mp="3hju8z1644bk4">{b.title}</h3>
                <p className="mt-3 text-base leading-relaxed text-muted" data-id="element-81" data-mp="3qipeeb1c1hmd">{b.body}</p>
                <p className="mt-3 text-base font-semibold text-brand-700" data-id="element-82" data-mp="3qglaht3foim3">{b.note}</p>
              </div>
            </article>)}
        </div>

        <div className="px-5 md:px-8" data-id="element-83" data-mp="2xv1y3873hd5j">
          <p className="mt-12 text-center text-xl font-bold text-gold-300" data-id="element-84" data-mp="2xrxlpnjh7b3s">
            All 5 bonuses are included with your complete collection.
          </p>
          <SectionCTA label="Yes! Include my 5 exclusive bonuses" tone="dark" data-id="element-85" data-mp="37kv8i5vi3m87" />
        </div>
      </div>
    </section>;
}